<app-top-bar />
<app-create-post-modal />
<div class="adminLayout">
  <app-sidebar />
  <app-mobile-sidebar />
  <div class="layoutWrapper">
    <router-outlet />
  </div>
</div>
<!-- <app-minimize-post /> -->
<!-- <app-thank-you-popup /> -->

<!-- <app-plan-expired-popup /> -->
<!-- <app-plan-upgrade-popup /> -->
<!-- <app-post-published-popup /> -->
